import React from "react";
import apiPreview from "@/apis/preview/preview";
import OpenData from '@/components/open-data/open-data';
import * as wwLocal from '@wecom/jssdk'
import _ from 'lodash';

let setTimer = null;

export const debounceFunc = (callback, delay) => {
  let timer = null;
  return function () {
    let self = this;
    let args = arguments;
    timer && clearTimeout(timer);
    timer = setTimeout(function () {
      callback.apply(self, args);
    }, delay);
  };
};
// 防抖
export const debounce = (func, wait, immediate) => {
  let timeout;
  return function (...args) {
    window.clearTimeout(timeout);
    timeout = setTimeout(() => {
      timeout = null;
      if (!immediate) func.apply(this, args);
    }, wait);
    if (immediate && !timeout) func.apply(this, [...args]);
  };
}

// 节流
export const throttle = function (fn, delay) {
  let timer = null;
  return function () {
    let context = this
    let args = arguments
    clearTimeout(timer)
    timer = setTimeout(function () {
      fn.apply(context, args);
    }, delay);
  };
};

// 从url获取指定参数
export const getParameterByName = (name, byHash = false) => {
  name = name.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
  const regex = new RegExp(`[?&]${name}=([^&#]*)`);
  let results ='';
  if( location['pathname'] !== '/wx/home'){
    results = regex.exec(location[byHash ? 'hash' : 'search']);
  }else{
    results = regex.exec(decodeURIComponent(location['search']));
  }
  return results == null ? '' : decodeURIComponent(results[1]);
}

// 从url移除指定参数
export const removeURLParameter = (url, parameter) => {
  let urlParts = url.split('?');
  if (urlParts.length >= 2) {
    //参数名前缀
    let prefix = encodeURIComponent(parameter) + '=';
    let pars = urlParts[1].split(/[&;]/g);

    //循环查找匹配参数
    for (let i = pars.length; i-- > 0;) {
      if (pars[i].lastIndexOf(prefix, 0) !== -1) {
        //存在则删除
        pars.splice(i, 1);
      }
    }
    return urlParts[0] + (pars.length > 0 ? '?' + pars.join('&') : '');
  }
  return url;
}

// 文件大小转换
export const calFileSize = (size) => {
  if (!/^-?\d+(\.\d+)?$/g.test(size)) {
    return
  }
  size = parseFloat(size)
  if (size < 1024) {
    return `${(size).toFixed(1)}B`
  }
  if (size >= 1024 && size < 1024 * 1024) {
    return `${(size / 1024).toFixed(1)}K`
  }
  if (size >= 1024 * 1024 && size < 1024 * 1024 * 1024) {
    return `${(size / (1024 * 1024)).toFixed(1)}M`
  }
  if (size >= 1024 * 1024 * 1024) {
    return `${(size / (1024 * 1024 * 1024)).toFixed(1)}G`
  }
}

// 从字符串中识别出链接
export const replaceSrc = (txt) => {
  let reg = /(((https?:(?:\/\/)?)(?:[-;:&=+$,\w]+@)?[A-Za-z0-9.-]+|(?:www.|[-;:&=+$,\w]+@)[A-Za-z0-9.-]+)((?:\/[+~%/.\w-_]*)?\??(?:[-+=&;%@.\w_]*)#?(?:[\w]*))?)/ig;
  if (txt) {
    return txt.replace(reg, function (item) {
      let c
      let reg = /(http|https):\/\/([\w.]+\/?)\S*/
      if (reg.test(item)) {
        c = item
      } else {
        c = `http://${item}`
      }
      return "<a href='" + c + "' target='_blank'>" + item + "</a>";
    })
  }
}

// 获取图片宽高
export const checkImgWidth = async (fileUrl) => {
  return new Promise((resolve) => {
    let img = new Image();
    let res = {}

    img.onload = function () {
      res = {
        width: this.width,
        height: this.height
      }
      resolve(res)
    }
    img.src = fileUrl
  })
}

// 获取神策地址
export const getSensorsProject = () => {
  if (process.env.NODE_ENV === 'development') {
    // 本地
    return process.env.SENSOR_PROJECT
  } else {
    // 线上
    return SERVER.sensorProject
  }
}

// 限制字符串最大自数
export const limitString = (value, maxLength) => {
  if (!value) return ''
  if (value.length > maxLength) {
    return value.substring(0, maxLength) + '...'
  } else {
    return value
  }
}

// 最大数字处理
export const limitNumber = (value, maxValue = 999) => {
  if (value <= maxValue) {
    return `(${value})`
  } else if (value > maxValue) {
    return '(999+)'
  } else {
    return ''
  }
}

// 上传神策自定义事件
export const sensorsTrack = (event, data = {}) => {
  const name = `traffic_${getSensorsProject()}_${event}`;
  const projectConfig = {
    ikcrm: '独立',
    wxwork: '企业微信',
    dingtalk: '钉钉'
  }
  const proName = projectConfig[window.crm_app_type || 'ikcrm']
  const projectSettings = {
    platform_type: 'PC',
    brand: window.theme_style === 'blue' ? '爱客' : '励销',
    project_name: proName,
    product: 'SCRM',
  }
  // window.sensorReporter 由sensors项目注入容器
  window.sensorReporter && window.sensorReporter.sa.track(name, {
    ...data,
    ...projectSettings
  })
}

// 高亮关键词
export const highlightText = (text, key) => {
  if (key && text && typeof text === 'string' && typeof key === 'string') {
    const newTextArr = text.split("").map(t => {
      return key.toLowerCase().indexOf(t.toLowerCase()) > -1 ? `<Fragment style=color:#FC8352>${t}</Fragment>` : t;
    });
    const newText = newTextArr.join("");
    return <span dangerouslySetInnerHTML={{ __html: newText }} />
  } else {
    return text;
  }
}
// active: Boolean 做为判断依据
// compareT和compareF是作为判断后结果输出
export function isActiveReturnCompare(active, compareT, compareF) {
  return active ? compareT : compareF;
}

// 移动端像素
export function pixel2vw($pixel) {
  return (($pixel / 750) * 100) + 'vw';
}

// 动态夺取屏幕高度
export function getHeight() {
  return (window.innerHeight)
}

export function browser(u) {
  var browser = {
    versions: function () {
      return {//移动终端浏览器版本信息
        trident: u.indexOf('Trident') > -1, //IE内核
        presto: u.indexOf('Presto') > -1, //opera内核
        webKit: u.indexOf('AppleWebKit') > -1, //苹果、谷歌内核
        gecko: u.indexOf('Gecko') > -1 && u.indexOf('KHTML') === -1, //火狐内核
        mobile: !!u.match(/AppleWebKit.*Mobile.*/), //是否为移动终端
        ios: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/), //ios终端
        android: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1, //android终端或者uc浏览器
        iPhone: u.indexOf('iPhone') > -1, //是否为iPhone或者QQHD浏览器
        iPad: u.indexOf('iPad') > -1, //是否iPad
        webApp: u.indexOf('Safari') === -1 //是否web应该程序，没有头部与底部
      };
    }(),
    language: (navigator.browserLanguage || navigator.language).toLowerCase()
  }
  //移动端
  return browser.versions.mobile || browser.versions.ios || browser.versions.android || browser.versions.iPhone || browser.versions.iPad
}

export function getBrowser() {
  var userAgent = navigator.userAgent;
  if (userAgent.indexOf("Opera") > -1 || userAgent.indexOf("OPR") > -1) {
    return 'Opera';
  } else if (userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1) {
    return 'IE';
  } else if (userAgent.indexOf("Edge") > -1) {
    return 'Edge';
  } else if (userAgent.indexOf("Firefox") > -1) {
    return 'Firefox';
  } else if (userAgent.indexOf("Safari") > -1 && userAgent.indexOf("Chrome") == -1) {
    return 'Safari';
  } else if (userAgent.indexOf("Chrome") > -1 && userAgent.indexOf("Safari") > -1) {
    return 'Chrome';
  } else if (!!window.ActiveXObject || "ActiveXObject" in window) {
    return 'IE>=11';
  } else {
    return 'Unkonwn';
  }
}

export function buildShortUUID(prefix = "") {
  const time = Date.now();
  const random = Math.floor(Math.random() * 1000000000);
  return prefix + "_" + random + String(time);
}

// 动态插入js
export function loadJs(scriptUrl) {
  return new Promise(resolve => {
    const script_dom = document.createElement('script');
    script_dom.src = scriptUrl;
    script_dom.type = 'text/javascript';
    script_dom.onload = () => resolve(true)
    let body = document.getElementsByTagName('body')
    body[0].appendChild(script_dom)
  })
}

// 动态添加meta标签
export function addMeta(name, content) {
  return new Promise(resolve => {
    let meta = document.createElement('meta');
    meta.content = content;
    meta.name = name;
    document.getElementsByTagName('head')[0].appendChild(meta);
    resolve(true);
  })
}

// 动态添加meta标签
export function addHttpMeta(httpEquiv, content) {
  return new Promise(resolve => {
    let meta = document.createElement('meta');
    meta.content = content;
    meta.httpEquiv = httpEquiv;
    document.getElementsByTagName('head')[0].appendChild(meta);
    resolve(true);
  })
}

// 判断是否为IPV4地址
export function isValidIP(ip) {
  if (ip === "localhost") return true;
  let ipv4Reg = /^(?!\.)((^|\.)([1-9]?\d|1\d\d|2(5[0-5]|[0-4]\d))){4}$/gm;
  return ipv4Reg.test(ip)
}

//根据可视窗口计算Table列表的高度
export function countTableHeight() {
  //浏览器可视窗口高度-顶部导航栏高度-页头-列表操作区高度-底部分页高度- 外层div的margin-table的列表表头+中间段的margin和padding
  let tableHeight = document.body.clientHeight - 60 - 64 - 64 - 60 - 24 - 55 + 24;
  return tableHeight;
}

// 取当前时间的前后100年，flag为1前100年，其他为后100年
export function formatDate(date, flag) {
  let y = flag === 1 ? (date.getFullYear() - 100) : (date.getFullYear() + 100);
  let m = date.getMonth() + 1;
  m = m < 10 ? ('0' + m) : m;
  let d = date.getDate();
  d = d < 10 ? ('0' + d) : d;
  let h = date.getHours();
  h = h < 10 ? ('0' + h) : h;
  let minute = date.getMinutes();
  minute = minute < 10 ? ('0' + minute) : minute;
  let second = date.getSeconds();
  second = second < 10 ? ('0' + second) : second;
  let time = y + '-' + m + '-' + d + ' ' + h + ':' + minute + ':' + second;
  return new Date(time);
}

// 获取日期对应的星期x
export function getWeekDay(day) {
  const today = [
    '星期天',
    '星期一',
    '星期二',
    '星期三',
    '星期四',
    '星期五',
    '星期六',
  ];
  return today[day.getDay()];
}

// 获取数据类型
export function getType(val) {
  let type = Object.prototype.toString
    .call(val)
    .toLowerCase()
    .replace(/\[\w+\s(\w+)\]/, '$1');

  return React.isValidElement(val) ? 'react' : type;
}

// 检查数据类型
export function checkType(val, typeList) {
  let type = getType(val);
  return type == typeList || typeList.indexOf(type) > -1 ? true : false;
}

// 电话号码验证
export function phoneCkeck(value) {
  const reg = /(^(\d{3,4}-)?\d{7,8})$|(1[0-9]{9})/;
  return reg.test(value);
}

// 邮箱验证
export function emailCheck(value) {
  const reg = /^[A-Za-z0-9\u4e00-\u9fa5]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/;
  return reg.test(value);
}

function addZeroPrefix(number) {
  return number < 10 ? `0${number}` : number
}

export function getDate(date, splitor = '-') {
  const year = date.getFullYear()
  const month = date.getMonth() + 1
  const day = date.getDate()
  return `${year}${splitor}${addZeroPrefix(month)}${splitor}${addZeroPrefix(day)}`
}

export function getTime(date, withSecond = false) {
  const hour = date.getHours()
  const minute = date.getMinutes()
  const second = date.getSeconds()
  return withSecond ? `${addZeroPrefix(hour)}:${addZeroPrefix(minute)}:${addZeroPrefix(second)}` : `${hour}:${addZeroPrefix(minute)}`
}

export function getFullDate(date) {
  return `${getDate(date)} ${getTime(date)}`
}

/**
 * @name 判断iOS
 */
export const isiOS = () => {
  let u = navigator.userAgent;
  let iOs = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/); //ios终端\
  return iOs;
}
/**
* @name 判断android
*/
export const isAndroid = () => {
  let u = navigator.userAgent;
  let android = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1; //android终端
  return android
}
/**
* @name 驼峰替换成下划线
*/
export const camelToUnderline = (camelStr) => {
	return camelStr.replace(/[A-Z]/g,function(s){
		return ' '+s.toLowerCase();
	}).trim().replaceAll(' ','_');
}
/**
* @name 
*/
export const isSameArr = (arrA, arrB) => {
  let arrAlength = _.get(arrA, 'length', 0);
  let arrBlength = _.get(arrB, 'length', 0);
  if (arrAlength != arrBlength) {
    return false;
  } else {
    let tempB = _.cloneDeep(arrB);
    let tempBEmpty = [];
    _.each(arrA, (item) => {
      let tempIndex = _.findIndex(tempB, (subB) => {
        return (
          _.get(subB, 'key', 1) == _.get(item, 'key', 0) &&
          _.get(subB, 'id', 1) == _.get(item, 'id', 0) &&
          _.get(subB, 'value', 1) == _.get(item, 'value', 0)
        );
      });
      if (tempIndex != -1) {
        tempBEmpty.push(_.cloneDeep(_.get(tempB, `[${tempIndex}]`)));
      }
    });
    return _.get(tempBEmpty, 'length') == _.get(tempB, 'length');
  }
};
/**
* @name 处理选人选部门接口
*/
export function composeUserSelect(obj) {
  let treeData = [];
  _.each(obj, (item, key) => {
    if (Array.isArray(item)) {
      //是部门
      _.each(item, (subItem) => {
        subItem['key'] = _.get(subItem, 'id', '');
        subItem['title'] = (
          <OpenData
            type="departmentName"
            openid={_.get(subItem, 'third_dept_id')}
          >
            {_.get(subItem, 'name', '')}
          </OpenData>
        );
        treeData.push(subItem);
      });
    } else {
      //是人员
      let userArr = _.get(item, 'users', []);
      _.each(userArr, (user) => {
        user['isLeaf'] = true;
        user['key'] = _.get(user, 'id', '');
        user['title'] = (
          <OpenData type="userName" openid={_.get(user, 'third_userid', '')}>
            {_.get(user, 'name', '')}
          </OpenData>
        );
        treeData.push(user);
      });
    }
  });
  obj = treeData;
  return treeData;
}
/**
* @name 
*/
export const BubbleJudgmentPrompt =  (text, number)=> {
  if (!number) {
    number = 6;
  }
  let len = 0;
  if (text) {
    for (let i = 0; i < text.length; i++) {
      let a = text.charAt(i);
      if (a.match(/[^\x00-\xff]/gi) != null) {
        len += 2;
      } else {
        len += 1;
      }
    }
    if (!_.isEmpty(text)) {
      if (len > number) {
        return true;
      } else {
        return false;
      }
    } else {
      return false;
    }
  }
};

// 获取path
export function eventPathFunc(evt) {
  const path = evt.path || (evt.composedPath && evt.composedPath()),
    target = evt.target;

  if (path != null && path.length > 0) {
    return path;
  }

  if (target === window) {
    return [window];
  }

  function getParents(node, memo) {
    memo = memo || [];
    const parentNode = node.parentNode;

    if (!parentNode) {
      return memo;
    } else {
      return getParents(parentNode, memo.concat(parentNode));
    }
  }
  return [target].concat(getParents(target), window);
}
//处理选所属部门接口
export function composeDepartmentSelect(obj) {
  let treeData = [];
  _.each(obj, (item, key) => {
    if (Array.isArray(item)) {
      //是部门
      _.each(item, (subItem) => {
        subItem['key'] = _.get(subItem, 'id', '');
        subItem['title'] = (
          <OpenData
            type="departmentName"
            openid={_.get(subItem, 'third_dept_id', '')}
          >
            {_.get(subItem, 'name', '')}
          </OpenData>
        );
        treeData.push(subItem);
      });
    }
  });
  obj = treeData;
  return treeData;
}

// 获取url参数
export const getUrlQuery = (search) => {
  if (!search) return {};
  let idx = search.indexOf('?')
  if (idx!=-1) {
    search = search.substr(idx+1)
  }
  let list = search.split('&')
  let rs = {}
  for (let i=0; i<list.length; i++) {
    let arr = list[i].split('=')
    if (arr[0] && arr[1]) {
      rs[arr[0]] = arr[1]
    }
  }
  return rs
}

export function getWxMessageType(msgtype) {
  const messageList = {
    1:	'文本',
    2:	'图片',
    3:	'表情',
    4:	'链接',
    5:	'小程序',
    6:	'语音',
    7:	'视频',
    8: '文件',
    9:	'名片',
    10:	'转发消息',
    11:	'视频号',
    12:	'日程',
    13:	'红包',
    14:	'地理位置',
    15:	'快速会议',
    16:	'待办',
    17:	'投票',
    18:	'在线文档',
    19:	'图文消息',
    20:	'图文混合消息',
    21:	'音频存档',
    22:	'音视频通话',
    23:	'微盘文件',
    24:	'同意会话存档',
    25:	'拒绝会话存档',
    26:	'群接龙',
    27:	'markdown',
  }
  return messageList[msgtype] || '无法识别的消息'
}

// 获取jsApi
export const jsApiList = [
  'onMenuShareAppMessage', 'onMenuShareWechat', 'startRecord', 'stopRecord', 'onVoiceRecordEnd',
  'playVoice', 'pauseVoice', 'stopVoice', 'onVoicePlayEnd', 'uploadVoice', 'downloadVoice',
  'chooseImage', 'previewImage', 'uploadImage', 'downloadImage', 'getNetworkType', 'openLocation',
  'getLocation','hideOptionMenu', 'showOptionMenu', 'hideMenuItems', 'showMenuItems', 'hideAllNonBaseMenuItem',
  'showAllNonBaseMenuItem', 'closeWindow', 'scanQRCode', 'openDefaultBrowser', 'wwapp.invokeJsApiByCallInfo',
  'openAppManage'
];

// 获取随机数
export const randomString = (len) => {
  len = len || 32;
  var $chars = 'ABCDEFGHJKMNPQRSTWXYZabcdefhijkmnprstwxyz2345678'; /****默认去掉了容易混淆的字符oOLl,9gq,Vv,Uu,I1****/
  var maxPos = $chars.length;
  var pwd = '';
  for (let i = 0; i < len; i++) {
    pwd += $chars.charAt(Math.floor(Math.random() * maxPos));
  }
  return pwd;
}


export const isWorkWechat = () => {
  var ua = window.navigator.userAgent.toLowerCase();
  if (ua.match(/micromessenger/i) === 'micromessenger' && ua.match(/wxwork/i) === 'wxwork') {
    return true;
  } else {
    return false;
  }
}
  

// 生成会话宝签名
export const getThirdWxConfig = ({corpId, thirdAgentId}) => {
  return new Promise((resolve, reject) => {
    const wwSDK = window.ww || (isWorkWechat() ? null : wwLocal);
    const timestamp = new Date().getTime();
    const noncestr = randomString(8);
    apiPreview.autographThird({ url: location.href.split('#')[0], timestamp, noncestr }).then(res => {
      var configParams = window.configParams || {};
      configParams.timestamp = timestamp;
      configParams.nonceStr = noncestr;
      configParams.signature = res.data.jsapi_signature;
      const agentconfigParams = {
        corpid: corpId,
        agentid: thirdAgentId,
        timestamp: timestamp,
        nonceStr: noncestr,
        signature: res.data.jsagent_signature,
        jsApiList: window.jsApiList || jsApiList,
        success: function(res) {
          window.WWOpenData && WWOpenData.bindAll(document.querySelectorAll('ww-open-data'));
          let rebindAll = function (){
            var arr = document.querySelectorAll('ww-open-data');
            arr.forEach(function(el) {
              if (!el.getAttribute('data-bind')) {
                el.setAttribute('data-bind', true);
                window.WWOpenData && WWOpenData.bind(el);
              }
            })
          }
          function callRebindAll(){
            rebindAll();
            setTimeout(callRebindAll, 500)
          }
          callRebindAll();
        }
      }
      wx.config(configParams);
      wx.ready(function() {
        wx.agentConfig(agentconfigParams)
      })
      wwSDK.register({
        corpId: corpId, // 必填，企业微信的corpid，必须与当前登录的企业一致
        agentId: thirdAgentId, // 必填，企业授权了第三方应用或代开发应用后的应用id （e.g. 1000247）
        jsApiList: window.jsApiList || jsApiList,
        async getAgentConfigSignature() {
          // 获取并返回 agentConfig 签名信息
          return {
            timestamp: timestamp,
            nonceStr: noncestr,
            signature: res.data.jsagent_signature,
          }
        },
        onAgentConfigSuccess(res) {
          console.info('签名成功-onAgentConfigSuccess', res)
        },
        onAgentConfigFail(res) {
          console.info('签名失败-onAgentConfigFail', res)
        },
        onAgentConfigComplete(res) {
          console.info('签名完成-onAgentConfigComplete', res)
        },
      })
      setTimeout(() => {
        if (res.data.jsagent_signature) {
          resolve('success');
        } else {
          reject('error')
        }
      }, 500)
    }).catch(error => {
      console.log(error)
    })
  });
}
// 跳转
export const hrefChangeUrl = (url, type) => {
  // window.location.href = url;
  // let tempUrl = url;
  // if (_.get(window,'platform_dingoxm')) {
  //   if (!/^https?:\/\//.test(url) && !/^\//.test(url) && !/^#/.test(url)
  //   ) {  
  //     tempUrl = '/' + url;  
  //   }
  //   if (window.updateQueryStringIfNeeded) {
  //     tempUrl = window.updateQueryStringIfNeeded({
  //       paramUrl: url,
  //       paramName: 'user_token',
  //       paramValue: window?.publicVariablesHub?.currentUser?.userToken,
  //     });
  //   }
  // }
  
  if (window.lxyassign) {
    window.lxyassign({
      url: url,
      type: type || 'href',
    })
    return;
  }
  if (type === 'open') {
    window.open(url);
    return
  }
  window.location.href = url;
}

// 防抖
export const timerFn = (t, cb) => {
  t && clearTimeout(t);
  t = setTimeout(() => {
    cb && cb();
    clearTimeout(t);
    t = undefined;
  }, 1000);
}
